import { CommonSettings } from './settings';
import { Channel, AliceApp } from './skill';
import { BackendSettings, PublishingSettings } from './settings';
import { AgeRestriction, AppVersionInfoWithTargetPlatforms } from 'client/types';

export enum DraftStatus {
    InDevelopment = 'inDevelopment',
    ReviewRequested = 'reviewRequested',
    ReviewApproved = 'reviewApproved',
    DeployRequested = 'deployRequested',
}

export enum DraftStatusSmartHome {
    InDevelopment = 'inDevelopment',
    ReviewRequested = 'reviewRequested',
    MeetingApproval = 'meetingApproval',
    WaitingForTesting = 'waitingForTesting',
    DevicesTesting = 'devicesTesting',
    DevicesTestingCompleted = 'devicesTestingCompleted',
    ReviewApproved = 'reviewApproved',
    DeployRequested = 'deployRequested',
}

export type DraftStatusMap<T> = T extends Channel.SmartHome ? DraftStatusSmartHome : DraftStatus;

export const getDraftStatusMap = (channel: Channel) => {
    if (channel === Channel.SmartHome) return DraftStatusSmartHome;
    return DraftStatus;
};

export type DraftStatusType<TChannel extends Channel> = TChannel extends Channel.SmartHome
    ? DraftStatusSmartHome
    : DraftStatus;

export interface Draft<TChannel extends Channel, BS extends BackendSettings, PS extends PublishingSettings>
    extends CommonSettings<BS, PS> {
    channel: TChannel;
    updatedAt: string;
    status: DraftStatusType<TChannel>;
    isAllowedForDeploy: boolean;
    isTrustedSmartHomeSkill: boolean;
}

export interface AppDraftTrait {
    apkInfoWithTargets: Partial<AppVersionInfoWithTargetPlatforms>;
    logoUrl: string;
    screenshots: { imageUrl: string }[];
    ageRestriction?: AgeRestriction;
    targetPlatforms: string[];
}

export const isInDevelopment = (aliceApp: AliceApp) => {
    return [DraftStatus.InDevelopment, DraftStatusSmartHome.InDevelopment].includes(aliceApp.draft.status);
};

export const SMART_HOME_VALIDATION_TYPES = [
    'availability',
    'user_unlink',
    'devices',
    'devices_query',
    'devices_action',
] as const;
export type SmartHomeValidationType = (typeof SMART_HOME_VALIDATION_TYPES)[number];
export type SmartHomeValidationResponse = {
    http_code: number;
    http_method: string;
    status: 'OK' | 'TIMEOUT' | 'NOT_FOUND' | 'PROVIDER_INTERNAL_ERROR' | 'SSL_CHECK_FAILED';
    url: string;
};
export type SmartHomeValidationStatuses = Record<SmartHomeValidationType, SmartHomeValidationResponse>;
